import { render, staticRenderFns } from "./UOMListAddNew.vue?vue&type=template&id=cb3bb90e"
import script from "./UOMListAddNew.vue?vue&type=script&lang=js"
export * from "./UOMListAddNew.vue?vue&type=script&lang=js"
import style0 from "./UOMListAddNew.vue?vue&type=style&index=0&id=cb3bb90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports